import styled from 'styled-components';

export const DataCollectorDashboardWrapper: any = styled.div` 

.pageContent{
    padding-top: 150px;
}
.pageContent .contentSection{
    margin: 0px 0px;
    min-height: 600px;
}
.pageContent .contentClosedSection{
    margin: 0px 0px;
    min-height: 375px;
}
.dashboardWebinarScreen .pageContent{
    padding-top: 100px;
} 
.width10{
    width: 10%;
    padding: 4px 10px;
}
.enabledModule{
    color: #0099ff;
}

.disabledModule{
    color: #969696;
}
.dataDashboardScreen .pageTitleSection{
    left: -30px;
}

.dataDashboardScreen .pagesLinks ul{
    margin: 0px;
}

.dashboardWebinarScreen .media-list-wrapper .media-list{
    cursor: pointer;
}

// Footer CSS
.dataDashboardScreen .pageContent .footerSection{
    padding: 15px 15px;
}
.footerSection  .alignLeft{
    width: 70%;
}
.footerSection .alignRight ul{
    margin: 0px;
}
.footerSection .alignRight ul li{
    list-style: none;
    padding: 5px 0px;
}
.footerSection .alignRight ul li a{
    color: #aaa !important;
}
.footerSection .pageLink .footerIcon{
    position: relative;
    top: 7px;
}
// Footer CSS

.media-list-wrapper .media-list{ 
    padding: 20px 5%;
}
.media-list-wrapper .media-list:first-child{
    border-bottom: 2px solid #aaa;
}
.media-list-wrapper .media-list .media-body{
    width: 80%;
}
.media-list-wrapper .media-list .media-body h5{
    margin: 7px 0px;
}
.media-list-wrapper .media-list .media-body p{
    margin: 5px 0px;
}
.media-list-wrapper .media-list .media-body .captionText{
    text-transform: uppercase;
    font-size: 16px;
    color: #000;
}
.media-list .media-left, .media-list .media-body{
    display: inline-block;
    vertical-align: top;
}
.media-list .media-right{
    display: inline-block;
    padding: 20px 20px;
}
.media-list .media-box{
    padding: 15px 15px;
    margin-right: 15px;
    display: inline-table;
}
.media-box-success{
    color: #449d44;
}
.media-box-primary{
    color: #0099FF;
}
.media-disable{
    color: #0099FF;
}
.media-na{
    border: 2px solid #aaa;
    border-color: #aaa;
    color: #ccc;
    padding: 5px 5px;
    display: inline-block;
}
.media-module-disable{
    color: #ccc;
}
.media-module-disable *{
    color: #ccc;
}
.media-category-disable *{
    color: #ccc !important;
}
.media-list .media-box.media-box-success{
    border: 2px solid #449d44;
    border-color: #449d44;
    color: #449d44;
}
.media-list .media-box.media-box-primary{
    border: 2px solid #0099FF;
    border-color: #0099FF;
    color: #0099FF;
    display: inline-table;
}
.media-list .media-box.media-disable{
    border: 2px solid #ccc;
    border-color: #ccc;
    // color: #0099FF;
    display: inline-table;
}
.media-list .media-box-large{
    padding: 20px 20px;
}
.media-list .media-box-small{
    padding: 3px 3px;
}
.media-list .media-body .smallText{
    color: #aaa;
    font-size: 12px;
}
.media-list .media-content-divided{
    width: 46% !important;
    float: left;
    // margin: 0px 15px;
    padding: 10px 25px;
}
.media-list .media-content-divided:first-child{
    border-right: 2px solid #aaa;
    padding-left: 0px;
}
.media-list .media-content-divided + .media-content-divided{
    width: 100%;
}
.media-video .OndemandVideoIcon{
    font-size: 48px;
}

.media-box .ArchiveOutlinedIcon{
    font-size: 48px;
}

.iframe-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
}
.iframe-wrapper .iframe-webinar-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

// Progress Bar Dashboard CSS
.progress {
    height: 5px;
    // margin-bottom: 20px;
    overflow: hidden; 
    background-color: #f5f5f5;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
}
.progress-bar {
    float: left;
    width: 0%;
    height: 100%;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
    background-color: #337ab7;
    -webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
    -webkit-transition: width .6s ease;
    -o-transition: width .6s ease;
    transition: width .6s ease;
}
.progress-bar-success {
    background-color: #5cb85c;
    // width: 100%;
}
.progress-bar-primary {
    background-color: #0099FF;
    width: 50%;
}
// Progress Bar Dashboard CSS

// Media Expansion Panel CSS
.media-content-acc-group .MuiExpansionPanelSummary-expandIcon-234{
    color: #0099FF;
}
.media-content-acc-group .ExpansionPanelDetails .media-heading{
    width: 100%;
    text-align: left;
    position: relative;
}
.ExpansionPanelDetails .media-heading .btn-blue-primary{
    position: absolute;
    right: 0px;
    top: 0px;
    border-radius: 0px;
    min-width: 50px;
}
.media-content-acc-group .ExpansionPanel{
    box-shadow: none;
    position: relative;
    margin: 20px 0px;
    background: 0px;
}
.media-content-acc-group .ExpansionPanel .progress{
    width: 100%;
    position: absolute;
    padding: 0px;
    bottom: 0px;
    margin-bottom: 0px;
}
.media-content-acc-group .ExpansionPanel .ExpansionPanelSummary{
    padding: 0px !important;
    position: relative;
}
.media-content-acc-group .MuiExpansionPanelSummary-expandIcon-234{
    color: #0099FF;
}
.media-content-acc-group .ExpansionPanel{
    box-shadow: none;
    position: relative;
    margin: 20px 0px;
    background: 0px;
}
.media-content-acc-group .ExpansionPanel .progress{
    width: 100%;
    position: absolute;
    padding: 0px;
    bottom: 0px;
    margin-bottom: 0px;
}
.media-content-acc-group .ExpansionPanel .ExpansionPanelSummary{
    padding: 0px;
    position: relative;
    margin: 12px 0;
    display: flex;
    width: 100%;
    padding: 15px 0px;
}
.ExpansionPanel .ExpansionPanelSummary .ExpansionPanelSummaryContent{
    margin: 12px 0px;
    display: flex;
    flex-grow: 1;
}
.ExpansionPanelCategory{
    margin: 25px 0px !important;
}
.ExpansionPanelSummaryNone .MuiExpansionPanelSummary-expanded-282{
    margin: 12px 0;
}
.ExpansionPanel .ExpansionPanelSummary .MuiIconButton-root-257{
    color: #0099FF;
}
.ExpansionPanel .ExpansionPanelSummary .media-heading{
    padding: 10px 15px;
    font-size: 16px;
    width: 100%;
}
.ExpansionPanel .ExpansionPanelSummary .media-heading p{
    font-size: 18px;
    color: #000;
}
.ExpansionPanel .ExpansionPanelDetails .surveyRedirect .btn-blue-primary{
    border-radius: 0px;
    min-width: 50px;
}
.ExpansionPanelDetails .media-box{
    // padding: 3px 3px;
    display: inline-block;
}
.media-content-acc-group .ExpansionPanel .ExpansionPanelSummary .[class*="MuiExpansionPanelSummary-expandIcon-"]{
    color: #0099FF;
}
.media-insidecontent-acc-group .ExpansionPanelSummary{
    padding: 0px;
}
// Media Expansion Panel CSS

.changeCountry{
    padding: 10px 0px;
    vertical-align: middle;
}
.media-webinar-heading {
    padding: 0px 5%;
}

.footerSection .alignLeft{
    padding-left: 4%;
}

`


// WEBPACK FOOTER //
// ./src/styles/datacollectordashboard.tsx